import { TROK0 } from "./TROK0";

export function TROKN() {
    return <div className='trok-main-width v-box gap-32'>
        <h2>Town Events</h2>
        <h3>All you need to know to get to know our town!</h3>
        <p>
            Triple Oaks is a wonderful place where stuff happens and people live.
            <br/>
            Nothing is here that shouldn't be here! Don't worry. Don't think. It's ok. You're maybe right to be suspicious but stop that anyway!
            <br/> <br/>
            There are so many things happening here that it's hard to summarize all of them. Just know -- it's a great town with many interesting places. Come and see them! Just one little walkie through town and you'll be like -- oh, neat! Huh!
        </p>
    </div>
}